import { Button, Grid, CssBaseline, FormControl, TextField, Snackbar, useTheme, useMediaQuery, FormHelperText, CircularProgress, Tooltip, MenuItem, Switch, InputLabel } from '@mui/material';
import Alert from '@mui/lab/Alert';
import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import useStyles from '../../../common/CommonStyle/CommonStyle'
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import IconRestore from '@mui/icons-material/AutorenewOutlined';
import IconSaveOrUpdate from '@mui/icons-material/SaveOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import CustomBreadCrumb from '../../../common/CustomBreadCrumb';
import { Controller, useForm, } from 'react-hook-form';
import _ from "lodash/fp";
import { useIntl } from "react-intl";
import CreateIcon from '@mui/icons-material/Add';
import ViewIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { CommonService } from '../../../../services';
import CommonBackDrop from '../../../common/BackDrop';
import { GlobalEdiApiConstants } from "../../../../Constants/GlobalEdiApiConstants";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import UserCombo from '../../../common/Combos/UserCombo/UserCombo';
import InfoIcon from '@mui/icons-material/Info';
import { MobileDatePicker } from '@mui/lab';
import CustomValuationSchedulerTab from './CustomValuationSchedulerTab'; 

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },

});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disabletypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(0),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const  CustomsValuationEmailEditConfigDialog = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const intl = useIntl();
    const commonPatterns = GlobalEdiApiConstants();

    const { onClose, open, title, mode, emailMessageConfigToBeEdited, supplierObjectToBeEditedOrView, customerObjectToBeEditedOrView } = props;
    const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [userValue, setUserValue] = useState({ id: '', userName: '' })
    const [componentList, setComponentList] = useState(title);
    const [saveOrUpdateButtonLabel, setSaveOrUpdateButtonLabel] = useState('');
    const [disableRestoreButton, isRestoreButtonDisabled] = useState(false);
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
    const [disableForReadMode, setDisableForReadMode] = useState(false);
    const [openBackDrop, setOpenBackDrop] = useState(false);
    const currentUser = CommonService.getLoggedInUserInfo();
    const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
    const [isResponseArrived, setResponseArrived] = useState(false);
    const [validFrom, changeValidFromDate] = useState(new Date());
    const [validToDate, changeValidToDate] = useState(null);
    const [emailConfigTobeConfigTobeEdited, setEmailConfigTobeConfigTobeEdited] = React.useState(emailMessageConfigToBeEdited);
    const [defaultToBeEdited, setDefaultToBeEdited] = useState({});
    const [loadSourceCodeInCreateMode, setLoadSourceCodeInCreateMode] = useState("");
    const [schedulerOpen, setSchedulerOpen] = useState(false);
    const [schedulerMode, setSchedulerMode] = useState('edit');
    const [schedulerFrequencyType, setSchedulerFrequencyType] = useState('alertEmail');
    const [alertEmailFrequency, setAlertEmailFrequency] = useState('');
    const [evalConfirmEmailFrequency, setEvalConfirmEmailFrequency] = useState('');    

    const handleClose = (value) => {
        setComponentList(title);
        onClose(value);
    }
    const [alertBoxState, setAlertBoxState] = React.useState({
        openAlert: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: ''
    });
    const handleCloseAlert = () => {
        setAlertBoxState({ ...alertBoxState, openAlert: false });
    };
    const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
    const pageLabelsConstantsAndMessages = {
        name: {
            countryCode: 'countryCode',
            contactNo: 'contactNo',
            emailTo: 'emailTo',
            emailCc: 'emailCc',
            emailBcc: 'emailBcc',
            validFrom: 'validFrom',
            validTo: 'validTo',
            status: 'status',
            source: 'source'
        },
        label: {
            contactPersonSalutation: 'Salutation',
            contactPersonName: 'Contact Person Name',
            contactPersonPhoneNo: 'Contact Person PhoneNo',
            contactPersonEmailId: 'Contact Person EmailID',
        },
    }
    const [emailMessageConfigReadOnlyFields, setEmailMessageConfigReadOnlyFields] = useState({
        
        countryCode: false,
        contactNo: false,
        emailTo: false,
        emailCc: false,
        emailBcc: false,
        validFrom: false,
        
        validToDate: false,
        source: false
    });
    const { handleSubmit, formState: { errors, isDirty, isValid }, control, reset, setValue } = useForm({
        mode: "all",
        reValidateMode: "all",
        defaultValues: {
            
            countryCode: '',
            contactNo: null,
            emailTo: '',
            emailCc: '',
            emailBcc: '',
            validFrom: '',
            
            validFrom: new Date(),
            validToDate: '',
            status: false,
            source: ''
        },
    });

    useEffect(() => {
        if (mode === 'edit' || mode === 'read') {
            setDefaultToBeEdited(emailConfigTobeConfigTobeEdited);
        }
    }, [mode, emailConfigTobeConfigTobeEdited])

    function resetEmailMesssageConfigValues(responseData) {
        reset({
            contactSalutation: responseData.contactSalutation !== undefined ? responseData.contactSalutation : '',
            contactName: responseData.contactName !== undefined ? responseData.contactName : '',
            project: responseData.project !== undefined ? responseData.project : '',
            countryCode: responseData.countryCode !== undefined ? responseData.countryCode : '',
            contactNo: responseData.contactNo !== undefined ? responseData.contactNo : '',
            user: (responseData.user !== null && responseData.user !== undefined) ? { id: responseData.user.id, userName: responseData.user.userName } : '',
            emailTo: responseData.emailTo !== undefined ? responseData.emailTo : '',
            emailCc: responseData.emailCc !== undefined ? responseData.emailCc : '',
            emailBcc: responseData.emailBcc !== undefined ? responseData.emailBcc : '',
            validFrom: responseData.validFrom !== undefined ? responseData.validFrom : '',
            validTo: (responseData.validTo !== null && responseData.validTo !== undefined) ? responseData.validTo : '',
            source: responseData.source !== undefined ? responseData.source : '',
            status: responseData.status !== undefined ? responseData.status : '',
        });
        setAlertEmailFrequency(responseData.alertEmailFrequency || '');
        setEvalConfirmEmailFrequency(responseData.evaluationConfirmationEmailFrequency || '');
        setUserValue((responseData.user !== null && responseData.user !== undefined) ? { id: responseData.user.id, userName: responseData.user.userName } : '')
        changeValidFromDate(new Date(responseData.validFrom));
        changeValidToDate((responseData.validTo !== null && responseData.validTo !== undefined) ? new Date(responseData.validTo) : null);
    }

    useEffect(() => {
        setEmailConfigTobeConfigTobeEdited(emailMessageConfigToBeEdited);
    }, [emailMessageConfigToBeEdited]);

    useEffect(() => {
        let currentRouterComponent;
        setValue(`${pageLabelsConstantsAndMessages.name.validFrom}`, validFrom, { shouldValidate: true, shouldDirty: true });
        if (mode === 'create') {
            isRestoreButtonDisabled(false);
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.save" defaultMessage="Save" />);
            setDisableForReadMode(false);
            currentRouterComponent = [
                {
                    path: null,
                    name: <FormattedMessage id="common.button.create.breadcrumb.tooltip" defaultMessage="Create" />,
                    iconName: CreateIcon,
                }
            ];
            changeValidFromDate(new Date());
            setLoadSourceCodeInCreateMode("Global EDI");
        } else if (mode === 'edit') {
            isRestoreButtonDisabled(false);
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.update" defaultMessage="Update" />);
            resetEmailMesssageConfigValues(emailConfigTobeConfigTobeEdited);
            setDisableForReadMode(false);
            setEmailMessageConfigReadOnlyFields({
                ...emailMessageConfigReadOnlyFields, contactSalutation: false, contactName: false, project: false, countryCode: false, contactNo: false, emailTo: false,
                emailCc: false, emailBcc: false, validFrom: false, user: false, validToDate: false
            })
            currentRouterComponent = [
                {
                    path: null,
                    name: <FormattedMessage id="common.tooltip.breadcrumb.edit" defaultMessage="Edit" />,
                    iconName: EditIcon,
                }
            ]
        } else if (mode === 'read') {
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.save" defaultMessage="Save" />);
            isRestoreButtonDisabled(true);
            setIsSaveButtonDisabled(true);
            resetEmailMesssageConfigValues(emailConfigTobeConfigTobeEdited);
            setDisableForReadMode(true);
            setEmailMessageConfigReadOnlyFields({
                ...emailMessageConfigReadOnlyFields, contactSalutation: false, contactName: false, project: false, countryCode: false, contactNo: false, emailTo: false,
                emailCc: false, emailBcc: false, validFrom: false, user: false, validToDate: false, status: true
            })
            currentRouterComponent = [
                {
                    path: null,
                    name: <FormattedMessage id="common.button.view.breadcrumb.tooltip" defaultMessage="View" />,
                    iconName: ViewIcon,
                }
            ]
        }
        setComponentList(title.concat(currentRouterComponent !== undefined ? currentRouterComponent : []));
    }, [mode, emailConfigTobeConfigTobeEdited]);

    const onSubmit = data => {
        data['custValConfigId'] = emailConfigTobeConfigTobeEdited.custValConfigId
        data['source'] = data.source;
        data['countryCode'] = data.countryCode;
        data['contactNo'] = data.contactNo;
        data['validFrom'] = data.validFrom;
        data['validTo'] = data.validTo;
        data['emailTo'] = data.emailTo;
        data['emailCc'] = data.emailCc;
        data['emailBcc'] = data.emailBcc;
        setResponseArrived(true);
        CommonService.saveOrUpdateOrPost(apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuationEmailMsgConfig, data)
            .then((response) => {
                setResponseArrived(false);
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: <FormattedMessage id="snackbar.recordupdatedsuccessfullypermission" defaultMessage="Record updated successfully" />, severity: "success" });
                onClose(true);
            })
            .catch(function (error) {
                setResponseArrived(false);
                setAlertBoxState({ ...alertBoxState, openAlert: true, message: error.response.data.message, severity: "error" });
            });
    }

    const userComboProperty = {
        name: pageLabelsConstantsAndMessages.name.user,
        isRequired: false,
        label: intl.formatMessage({ id: 'columnname.entitycontactname.label' }),
        isAutofocus: false,
        isDisabled: disableForReadMode,
        variant: 'outlined',
        isHookFormType: true,
        fieldNameToBeDisplayed: 'userName',
        errors: errors.user,
        // allowLogin: true
    }

    function resetAllClearThePageInfo() {
        if (mode === 'edit') {
            resetEmailMesssageConfigValues(emailConfigTobeConfigTobeEdited);
            setDefaultToBeEdited({ ...emailConfigTobeConfigTobeEdited })
        } else {
            reset({
                contactSalutation: '',
                contactName: '',
                project: '',
                countryCode: '',
                contactNo: '',
                emailTo: '',
                emailCc: '',
                emailBcc: '',
                validFrom: '',
                user: '',
                validFrom: '',
                validToDate: '',
                status: false
            });
            changeValidFromDate(new Date());
            setValue(`${pageLabelsConstantsAndMessages.name.validFrom}`, new Date(), { shouldValidate: true, shouldDirty: true });
            changeValidToDate(null);
            setEmailConfigTobeConfigTobeEdited({ ...emailConfigTobeConfigTobeEdited, status: false });
            setDefaultToBeEdited({ ...defaultToBeEdited, status: false })
        }
    };
   const fetchLatestConfigData = () => {
    const id = emailConfigTobeConfigTobeEdited?.custValConfigId;
    if (!id) return;

    setOpenBackDrop(true);

    CommonService.GetListApi(
        `${apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuationEmailMsgConfig}/${id}`,
        {}
    )
    .then((response) => {
        setOpenBackDrop(false);
        const freshData = response.data;
        console.log('Fetched latest config data:', freshData);
        setEmailConfigTobeConfigTobeEdited(freshData);
        resetEmailMesssageConfigValues(freshData);
    })
    .catch((error) => {
        setOpenBackDrop(false);
        setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error?.response?.data?.message || 'Failed to refresh data',
            severity: 'error'
        });
    });
};

    const handleOpenScheduler = (freqType) => {
    setSchedulerFrequencyType(freqType);
    setSchedulerMode(mode === 'read' ? 'read' : 'edit');
    setSchedulerOpen(true);
};

const handleSchedulerClose = (saved) => {
    setSchedulerOpen(false);
       if (saved) {
        fetchLatestConfigData(); 
    }
};

const handleSchedulerSave = (freqType, cronExp, timeZone) => {
    if (freqType === 'alertEmail') {
        setAlertEmailFrequency(cronExp);
    } else if (freqType === 'evaluationConfirmationEmail') {
        setEvalConfirmEmailFrequency(cronExp);
    }
};

    const onError = ((error) => {
    })

    useEffect(() => {
        if ((mode === 'edit') || (mode === 'create') || (mode === 'read')) {
            // setBpCode(customerObjectToBeEditedOrView === undefined ? supplierObjectToBeEditedOrView.bpCode : customerObjectToBeEditedOrView.bpCode)
            // setBpType(customerObjectToBeEditedOrView === undefined ? 'SUPPLIER' : 'CUSTOMER')
        }
    }, [customerObjectToBeEditedOrView, supplierObjectToBeEditedOrView])

    return (
        <React.Fragment>
            <CssBaseline />
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openAlert}
                onClose={handleCloseAlert}
                key={vertical + horizontal}
                autoHideDuration={6000}
            >
                <Alert onClose={handleCloseAlert} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
            <CommonBackDrop open={openBackDrop} />
            {schedulerOpen && (
             <CustomValuationSchedulerTab
              open={schedulerOpen}
              onClose={handleSchedulerClose}
              mode={schedulerMode}
              emailMessageConfigToBeEdited={emailConfigTobeConfigTobeEdited}
              frequencyType={schedulerFrequencyType}
               onSchedulerSave={handleSchedulerSave}
          />      
      )}
            <Grid container className={classes.root}>
                <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={12} lg={12}>
                    <Grid item container xs={12} sm={12} md={12} lg={12} >
                        <Dialog
                            fullWidth
                            maxWidth='lg'
                            aria-labelledby="create-or-delete-dialog"
                            open={open}>
                            <DialogTitle className={classes.titleCommonDialogComponent}  >
                                <Grid item container xs={12} sm={12} md={12} lg={12}>
                                    <Grid item container alignItems='center' xs={6} sm={8} md={8} lg={6} style={{ marginLeft: '-1.3%' }} >
                                        <CustomBreadCrumb componentList={componentList} isDialog={true} />
                                    </Grid>
                                    {/* <Grid item container justifyContent='flex-end' xs={6} sm={4} md={4} lg={6} style={{ color: '#fff', fontSize: '14px', marginLeft: '0.8%' }} >
                                        {bpType} | {bpCode}
                                    </Grid> */}
                                </Grid>
                            </DialogTitle>

                            <DialogContent dividers style={{ minHeight: '40vh' }} >
                                <Grid container className={classes.root}>
                                    <Grid item container xs={12} sm={12} md={12} lg={12} className={classes.textfieldSpacing}>
                                        <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing}>
                                            <form className={classes.form} onSubmit={handleSubmit(onSubmit, onError)}>
                                                <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing}>
                                                </Grid>
                                                <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing}>
                                                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                                                        <FormControl fullWidth>
                                                            <Controller
                                                                control={control}
                                                                name={pageLabelsConstantsAndMessages.name.emailTo}                                                  
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        required={true}
                                                                        className={classes.textField}
                                                                        variant="outlined"
                                                                        margin="normal"
                                                                        id="emailTo"
                                                                        size='small'
                                                                        multiline
                                                                        maxRows={2}
                                                                        label={intl.formatMessage({ id: "textfield.bpemailto.label" })}
                                                                        {...field}
                                                                        error={errors.emailTo}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                            classes: {
                                                                                asterisk: classes.asterisk
                                                                            }
                                                                        }}
                                                                        InputProps={{
                                                                            readOnly: emailMessageConfigReadOnlyFields.emailTo,
                                                                        }}
                                                                        disabled={disableForReadMode}
                                                                    />
                                                                )}
                                                            />
                                                            {(mode === 'edit' || mode === 'create') && <Grid item container justifyContent='flex-start' alignItems='center' xs={12} sm={6} md={12} lg={12}>
                                                                <FormHelperText><FormattedMessage id="texfield.placeholder.emailid.label"
                                                                    defaultMessage="Separate Multiple EmailID's with Semicolon(;)" /></FormHelperText>
                                                            </Grid>}
                                                            <div className={classes.error}>
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailTo}.type`, errors) === "required" && (
                                                                    <FormHelperText className={classes.error}>
                                                                        <FormattedMessage id="textfield.error.bpemailto" defaultMessage="BP Email To is required" />
                                                                    </FormHelperText>
                                                                )}

                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailTo}.type`, errors) === "maxLength" && (
                                                                    <FormHelperText className={classes.error}>
                                                                        {<FormattedMessage id="textfield.error.patternbpemailto" defaultMessage="Email Id cannot exceed more than 100 chars" />}
                                                                    </FormHelperText>
                                                                )}
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailTo}.type`, errors) === "pattern" && (
                                                                    <FormHelperText className={classes.error}> {<FormattedMessage id="textfield.bpemailto.label" defaultMessage="BP Email To" />} {commonPatterns.commonErrorsForTextFields.errorForEmailId}</FormHelperText>
                                                                )}
                                                            </div>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                                                        <FormControl fullWidth>
                                                            <Controller
                                                                control={control}
                                                                name={pageLabelsConstantsAndMessages.name.emailCc}
                                                                rules={{
                                                                    pattern: commonPatterns.commonTextfeildPattern.patternForEmailId
                                                                }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        className={classes.textField}
                                                                        variant="outlined"
                                                                        margin="normal"
                                                                        id="emailCc"
                                                                        size='small'
                                                                        multiline
                                                                        maxRows={2}
                                                                        label={intl.formatMessage({ id: "textfield.bpemailfrom.label" })}
                                                                        {...field}
                                                                        error={errors.emailCc}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                            classes: {
                                                                                asterisk: classes.asterisk
                                                                            }
                                                                        }}
                                                                        InputProps={{
                                                                            readOnly: emailMessageConfigReadOnlyFields.emailCc,
                                                                        }}
                                                                        disabled={disableForReadMode}
                                                                    />
                                                                )}
                                                            />
                                                            {(mode === 'edit' || mode === 'create') && <Grid item container justifyContent='flex-start' alignItems='center' xs={12} sm={6} md={12} lg={12}>
                                                                <FormHelperText><FormattedMessage id="texfield.placeholder.emailid.label"
                                                                    defaultMessage="Separate Multiple EmailID's with Semicolon(;)" /></FormHelperText>
                                                            </Grid>}
                                                            <div className={classes.error}>
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailCc}.type`, errors) === "required" && (
                                                                    <FormHelperText className={classes.error}>
                                                                        <FormattedMessage id="textfield.error.bpemailcc" defaultMessage="BP Email CC is required" />
                                                                    </FormHelperText>
                                                                )}
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailCc}.type`, errors) === "maxLength" && (
                                                                    <FormHelperText className={classes.error}>
                                                                        {<FormattedMessage id="textfield.error.patternbpemailto" defaultMessage="Email Id cannot exceed more than 100 chars" />}
                                                                    </FormHelperText>
                                                                )}
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailCc}.type`, errors) === "pattern" && (
                                                                    <FormHelperText className={classes.error}> {<FormattedMessage id="textfield.bpemailfrom.label" defaultMessage="BP Email CC" />} {commonPatterns.commonErrorsForTextFields.errorForEmailId}</FormHelperText>
                                                                )}
                                                            </div>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item container xs={12} sm={6} md={6} lg={6}>
                                                        <FormControl fullWidth>
                                                            <Controller
                                                                control={control}
                                                                name={pageLabelsConstantsAndMessages.name.emailBcc}
                                                                rules={{
                                                                    pattern: commonPatterns.commonTextfeildPattern.patternForEmailId
                                                                }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        className={classes.textField}
                                                                        variant="outlined"
                                                                        margin="normal"
                                                                        id="emailTo"
                                                                        size='small'
                                                                        multiline
                                                                        maxRows={2}
                                                                        label={intl.formatMessage({ id: "textfield.bpemailbcc.label" })}
                                                                        {...field}
                                                                        error={errors.emailBcc}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                        InputProps={{
                                                                            readOnly: emailMessageConfigReadOnlyFields.emailBcc,
                                                                        }}
                                                                        disabled={disableForReadMode}
                                                                    />
                                                                )}
                                                            />
                                                            {(mode === 'edit' || mode === 'create') && <Grid item container justifyContent='flex-start' alignItems='center' xs={12} sm={6} md={12} lg={12}>
                                                                <FormHelperText><FormattedMessage id="texfield.placeholder.emailid.label"
                                                                    defaultMessage="Separate Multiple EmailID's with Semicolon(;)" /></FormHelperText>
                                                            </Grid>}
                                                            <div className={classes.error}>


                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailBcc}.type`, errors) === "maxLength" && (
                                                                    <FormHelperText className={classes.error}>
                                                                        {<FormattedMessage id="common.textField.error.emailid" defaultMessage="Email Id cannot exceed more than 100 chars" />}
                                                                    </FormHelperText>
                                                                )}
                                                                {_.get(`${pageLabelsConstantsAndMessages.name.emailBcc}.type`, errors) === "pattern" && (
                                                                    <FormHelperText className={classes.error}> {<FormattedMessage id="textfield.bpemailbcc.label" defaultMessage="BP Email BCC" />} {commonPatterns.commonErrorsForTextFields.errorForEmailId}</FormHelperText>
                                                                )}
                                                            </div>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                {/* ── Frequency Configuration ── */}
                                              <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing} style={{ marginTop: '8px' }}>
                                                  <Grid item xs={12}>
                                                      <Typography variant="subtitle1" >
                                                          Frequency Configuration
                                                      </Typography>
                                                  </Grid>

                                                  {/* Alert Email Frequency */}
                                                  <Grid item container xs={12} sm={6} md={6} lg={6} alignItems="center" spacing={1}>
                                                      <Grid item xs={6}>
                                                          <FormControl fullWidth>
                                                              <TextField
                                                                  className={classes.textField}
                                                                  variant="outlined"
                                                                  size="small"
                                                                  label={intl.formatMessage({ id: "columnname.textfield.label.alertEmail" })}
                                                                  value={alertEmailFrequency}
                                                                  InputLabelProps={{ shrink: true }}
                                                                  InputProps={{ readOnly: true }}
                                                                  disabled={false}
                                                              />
                                                          </FormControl>
                                                      </Grid>
                                                      <Grid item>
                                                        <Tooltip title="Edit Frequency">
                                                          <Button
                                                                variant="contained"
                                                                color="primary"
                                                                size="medium"
                                                                onClick={() => handleOpenScheduler('alertEmail')}
                                                            >
                                                                <EditIcon />
                                                            </Button>
                                                        </Tooltip>  
                                                    </Grid>
                                                  </Grid>

                                                  {/* Evaluation Confirmation Email Frequency */}
                                                  <Grid item container xs={12} sm={6} md={6} lg={6} alignItems="center" spacing={1}>
                                                      <Grid item xs={6}>
                                                          <FormControl fullWidth>
                                                              <TextField
                                                                  className={classes.textField}
                                                                  variant="outlined"
                                                                  size="small"
                                                                  label={intl.formatMessage({ id: "columnname.textfield.label.EvaluationEmail" })}
                                                                  value={evalConfirmEmailFrequency}
                                                                  InputLabelProps={{ shrink: true }}
                                                                  InputProps={{ readOnly: true }}
                                                                  disabled={false}
                                                              />
                                                          </FormControl>
                                                      </Grid>
                                                      <Grid item>
                                                        <Tooltip title="Edit Frequency">
                                                          <Button
                                                                variant="contained"
                                                                color="primary"
                                                                size="medium"
                                                                onClick={() => handleOpenScheduler('evaluationConfirmationEmail')}
                                                            >
                                                                <EditIcon />
                                                            </Button>
                                                        </Tooltip>
                                                    </Grid>
                                                  </Grid>
                                              </Grid>
                                            </form>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </DialogContent>

                            {(!mobileScreen) && (
                                <DialogActions className={classes.dialogAction} >
                                    <Grid container justifyContent="flex-start" alignItems='center' xs={12} sm={12} md={12} lg={12} className={classes.textfieldSpacing} >
                                        {(mode === 'create' || mode === 'edit') ?
                                            <InfoIcon color="primary" /> : null}
                                        {(mode === 'create' || mode === 'edit') ?
                                            <Typography justifyContent="flex-start" style={{ fontSize: 12, marginLeft: '1%' }}><FormattedMessage id="textfield.placeholder.dialogActions" defaultMessage="All the '*' marked fields are mandatory to submit the form" /></Typography> : null}
                                    </Grid>
                                    <Grid container justifyContent='flex-end' alignItems='center' item xs={12} sm={12} md={12} lg={12} className={classes.commonDialogButtonSpacing} >
                                        <Button size='small' variant="contained" color="primary" className={classes.stateButton} elevation={2} endIcon={<ClearIcon />}
                                            onClick={() => handleClose(false)}
                                        ><FormattedMessage id="common.button.cancel.lable" defaultMessage="Cancel" />
                                        </Button>

										<Button size='small' variant="contained" color="secondary" className={classes.stateButtonToRestore}
										    disabled={disableRestoreButton} elevation={2} endIcon={<IconRestore />} onClick={(() => { resetAllClearThePageInfo() })}
                                        > <FormattedMessage id="common.button.reset.lable" defaultMessage="Restore" />
                                        </Button>                                     
                                        {(mode === 'edit') ?
                                            <Button size='small'
                                                variant="contained" color="primary" className={classes.stateButtonForSave} elevation={2}
                                                endIcon={isResponseArrived ? <CircularProgress color="secondary" size={20} /> : <IconSaveOrUpdate />}
                                                disabled={isResponseArrived || isSaveButtonDisabled || (!isDirty && isValid)}
                                                onClick={handleSubmit(onSubmit, onError)}>
                                                {saveOrUpdateButtonLabel}
                                            </Button> : <Button size='small'
                                                variant="contained" color="primary" className={classes.stateButtonForSave} elevation={2}
                                                endIcon={isResponseArrived ? <CircularProgress color="secondary" size={20} /> : <IconSaveOrUpdate />}
                                                disabled={isResponseArrived || isSaveButtonDisabled || (isDirty && !isValid)}
                                                onClick={handleSubmit(onSubmit, onError)}>
                                                {saveOrUpdateButtonLabel}
                                            </Button>}
                                    </Grid>
                                </DialogActions>
                            )}
                            {(mobileScreen) && (<Grid container justifyContent='center' alignItems='center' item xs={12} sm={12} md={12} lg={12}>
                                <DialogActions className={classes.dialogAction}>
                                    <Grid container justifyContent='center' alignItems='center' item xs={12} sm={12} md={12} lg={12}>
                                        <Tooltip title={<FormattedMessage id="common.button.cancel.lable" />}>
                                            <Button size='small' variant="contained" color="primary" className={classes.stateButtonForBack} elevation={2}
                                                onClick={() => handleClose(false)}
                                            >
                                                <ClearIcon />
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title={<FormattedMessage id="common.button.reset.lable" />}>
                                            <Button size='small' variant="contained" color="secondary" className={classes.stateButtonToRestore}
                                                disabled={disableRestoreButton} elevation={2} onClick={(() => { resetAllClearThePageInfo() })}><IconRestore />
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title={(mode === 'create') ? <FormattedMessage id="common.button.save" /> : <FormattedMessage id="common.button.update" />}>
                                            {(mode === 'edit') ?
                                                <Button size='small'
                                                    variant="contained" color="primary" className={classes.stateButtonForSave} elevation={2}
                                                    endIcon={isResponseArrived ? <CircularProgress color="secondary" size={20} /> : null}
                                                    disabled={isResponseArrived || isSaveButtonDisabled || (!isDirty && isValid)}
                                                    onClick={handleSubmit(onSubmit, onError)}>
                                                    <IconSaveOrUpdate /> </Button> :
                                                <Button size='small'
                                                    variant="contained" color="primary" className={classes.stateButtonForSave} elevation={2}
                                                    disabled={isResponseArrived || isSaveButtonDisabled || (isDirty && !isValid)}
                                                    endIcon={isResponseArrived ? <CircularProgress color="secondary" size={20} /> : null}
                                                    onClick={handleSubmit(onSubmit, onError)}>
                                                    <IconSaveOrUpdate /></Button>}
                                        </Tooltip>
                                    </Grid>
                                </DialogActions>
                            </Grid>)}
                        </Dialog>
                    </Grid>

                </Grid>
            </Grid>
        </React.Fragment >
    );
}
export default CustomsValuationEmailEditConfigDialog;
